var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16667 0C0.798477 0 0.5 0.298477 0.5 0.666667C0.5 1.03486 0.798477 1.33333 1.16667 1.33333H6.17543L0.695262 6.86193C0.434913 7.12228 0.434913 7.54439 0.695262 7.80474C0.955612 8.06509 1.37772 8.06509 1.63807 7.80474L7.16667 2.22728V7.33333C7.16667 7.70152 7.46514 8 7.83333 8C8.20152 8 8.5 7.70152 8.5 7.33333V0.666667C8.5 0.298477 8.20152 0 7.83333 0H1.16667Z",
    fill: "#00C408"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGreenIcon);
export default __webpack_public_path__ + "static/media/arrow-green-icon.e1a6109e4c6925ed0e3b5265bc328bbc.svg";
export { ForwardRef as ReactComponent };